import { buttonKey } from './';
export var createButtonDriver = function (wrapper, idx, additionalSelector) {
    if (idx === void 0) { idx = 0; }
    if (additionalSelector === void 0) { additionalSelector = ''; }
    var base = wrapper.$$("." + buttonKey + additionalSelector).get(idx);
    return {
        click: base.click,
        text: base.text,
        isDisabled: function () { return base.hasClass('disabled'); },
        isLoaderVisible: function () { return base.$('.tiny-loader').exists(); },
        hasTooltip: function () { return base.hasClass('has-tooltip'); },
        ariaLabel: function () { return base.attr('aria-label'); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map